<div class="otp-input" role="group" aria-label="One time password">
  <input
    #otpBox
    *ngFor="let i of indexes; trackBy: trackByIndex"
    class="otp-input__box"
    [class.otp-input__box--filled]="digits[i]"
    type="tel"
    inputmode="numeric"
    pattern="[0-9]*"
    maxlength="1"
    autocomplete="one-time-code"
    [attr.aria-label]="'Digit ' + (i + 1)"
    [value]="digits[i]"
    [disabled]="disabled"
    (input)="onInput($event, i)"
    (change)="onInput($event, i)"
    (keydown)="onKeydown($event, i)"
    (paste)="onPaste($event, i)"
    (focus)="onFocus($event)"
    (blur)="onTouched()"
  />
</div>
